import * as Sentry from '@sentry/browser'
import { EnvironmentNames } from 'constants/App'

const initSentry = () => {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  const environment = import.meta.env.VITE_ENV || EnvironmentNames.LOCAL

  // DSNがない場合、またはlocal環境の場合は初期化しない
  if (!dsn || environment === EnvironmentNames.LOCAL) {
    return
  }

  // 環境変数からサンプリングレートを取得（未定義の場合は0）
  const sampleRate = parseFloat(import.meta.env.VITE_SENTRY_SAMPLE_RATE || '0')
  const tracesSampleRate = parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || '0')

  Sentry.init({
    dsn,
    environment,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    sampleRate,
    tracesSampleRate,
    integrations: [
      Sentry.browserTracingIntegration({
        // INP（Interaction to Next Paint）を記録してインタラクション応答速度を測定
        // NOTE: 既定でも有効だが、設定意図を明示するため明示指定する
        enableInp: true,
        // WHY: デジタルガイド (Techtouch) はツールチップのルール評価ごとに performance.mark / measure を打ち、
        //      SDK はブラウザの User Timing エントリを既定で全て子 span にする。1 回の画面遷移あたり約 900 個で
        //      span 量の 99% を占め、請求期間分の quota を使い切って全プロジェクトの受信が止まったため、名前で除外する。
        //      名前で絞るのは、自前の performance.mark による計測を将来入れる余地を残すため。
        ignorePerformanceApiSpans: [/^player:/],
      }),
    ],

    beforeSend(event, hint) {
      // iOS Safari/WKWebViewの既知のバグによるエラーをフィルタリング
      // https://github.com/getsentry/sentry-javascript/issues/2342
      if (hint.originalException) {
        const exception = hint.originalException
        const errorMessage = exception.message || String(exception)
        if (
          errorMessage.includes('NotFoundError') &&
          errorMessage.includes('The object can not be found here')
        ) {
          return null // Sentryに送信しない
        }

        // APIエラーの場合、data.errors配列を展開
        if (exception.data && exception.data.errors && Array.isArray(exception.data.errors)) {
          event.extra = {
            ...event.extra,
            api_errors_detail: exception.data.errors,
          }
        }

        // レスポンスデータ全体も保存
        if (exception.response && exception.response.data) {
          event.extra = {
            ...event.extra,
            response_data_raw: JSON.stringify(exception.response.data, null, 2),
          }
        }

        // エラーメッセージの詳細化
        if (exception.message) {
          event.extra = {
            ...event.extra,
            error_message_detail: exception.message,
          }
        }
      }

      return event
    },
  })
}

export default initSentry
